module.exports = __webpack_public_path__ + "img/image-europa.cd73f80e.webp";